import DepartmentCard from './DepartmentCard';

export default DepartmentCard;